import Style from "./FloatingInputStyle";

export default function FloatingInput(props) {

  return (
    <Style>
      <div className="floating">
        <input {...props} className="floatingInput" placeholder={props.label} />
        <label className="floatingLabel" data-content={props.label}>
          <span className="hiddenVisually">
            {props.label}
          </span>
        </label>
      </div>
    </Style>
  );
}
